import { combineReducers } from "redux";
import { UserReducer } from "./reducer/reducer";
import { AutReducer } from "./reducer/userreducer";


const rootReducer = combineReducers({
  UserReducer,
  AutReducer
});

export default rootReducer;
